module.exports = __webpack_public_path__ + "img/0.e19b08c1.gif";